export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/createSchoolProfile',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allSchools'],
    })
